import React from 'react'
//assets
import addButton from '../assets/img/Panels__addButton.svg'
import '../assets/css/AddPanel.css'
//config
import config from '../config';
//Material UI Component
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import FormHelperText from '@material-ui/core/FormHelperText';
//components
import Hint from './Hint'

//store
import events from '../store/events';
import panels from '../store/panels';
import profile from '../store/profile';
import prompt from '../store/prompt';
import errors from '../store/errors';
import { observer } from 'mobx-react';
//plugin
import axios from 'axios';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 200
  },
  formControl: {
    minWidth: 200,
    marginTop: 10,
    // margin:'10px auto'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});

@observer
class AddPanel extends React.Component {
  state = {
    errorType: '',
    open: false,
    requireInputError: false,
    type: '',
    eventName: '',
    property: '',
    tool: '',
    submitConfirm: false,
    propertyDisable: true,
    toolDisable: true,
    typeDisable: true,
    eventDisable: false,
    propertyName:'屬性'
  }
  addPanel = this.addPanel.bind(this);
  handleClose = this.handleClose.bind(this);
  handleToolChange = this.handleToolChange.bind(this);
  handleTypeChange = this.handleTypeChange.bind(this);
  handleEventNameChange = this.handleEventNameChange.bind(this);
  handlePropertyChange = this.handlePropertyChange.bind(this);
  createPanel = this.createPanel.bind(this);
  addPanel() {
    this.setState({
      open: true
    })
  }
  handleClose() {
    this.setState({
      open: false,
      propertyDisable: true,
      toolDisable: true,
      typeDisable: true,
      eventDisable: false
    })
    this.props.editShow();
    this.clearState();
    //init newPanel Only Click Cancel
    let { tool, type, eventName, property, submitConfirm } = this.state;
    if (tool == '' || type == '' || eventName == '' || property == '') {
      panels.initPanel();
    }
  }
  clearState() {
    this.setState({
      tool: '',
      type: '',
      eventName: '',
      property: '',
      requireInputError: false,
      submitConfirm: false,
    })
  }
  createPanel() {
    //validate input
    let { tool, type, eventName, property, submitConfirm } = this.state;
    if (tool == '' || type == '' || eventName == '' || property == '') {
      //prompt Error message
      this.setState({
        submitConfirm: true,
        errorType: errors.type.empty,
      })
    } else {
      //Create panel on database
      if (this.props.show === 'add') {
        panels.createPanel();
      } else {
        let count = 0
        this.props.editShow();
        panels.newPanel.property = property;
        panels.newPanel.tool = tool;
        panels.newPanel.type = type;
        panels.list.map(x => {
          if (x.property === property && x.tool === tool && x.type === type) {
            count = count + 1;
          }
          return x
        })
        if (count !== 0) {
          prompt.message('修改的數據已存在，修改失敗,請重新修改...', 3500)
          return;
        }
        panels.updatePanel()
      }
      //Clear eventname and type state
      this.clearState();
      //Close dialog
      this.handleClose();
    }
  }
  handleToolChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim(),
      typeDisable: false,
      tool: event.target.value
    })
    panels.newPanel.tool = event.target.value.trim();
  }
  handleTypeChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim(),
      type: event.target.value
    })
    panels.newPanel.type = event.target.value;
  }
  handleEventNameChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      propertyDisable: false,
      eventName: event.target.value,
      propertyName:'屬性加載中...'
    })
    panels.newPanel.eventName = event.target.value;
    panels.getEventProperty();
  }
  handlePropertyChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      toolDisable: false,
      property: event.target.value,
      propertyName:'屬性'
    })
    panels.newPanel.property = event.target.value;
  }
  componentDidMount = () => {
    const { data } = this.props
    // 根据是否有data值，来判断是add还是edit
    if (this.props.data) {
      panels.newPanel.eventName = data.eventName;
      panels.newPanel.panelId = data.panelId;
      panels.getEventProperty();
      this.setState({
        open: true,
        tool: data.tool,
        type: data.type,
        eventName: data.eventName,
        property: data.property,
        submitConfirm: true,
        eventDisable: true,
        propertyDisable: false,
        toolDisable: false,
        typeDisable: false
      })
    } else {
      this.setState({
        propertyDisable: true,
        toolDisable: true,
        typeDisable: true,
        eventDisable: false
      })
    }
  }
  componentWillReceiveProps = () => {
    const { data } = this.props
    // 根据是否有data值，来判断是add还是edit
    if (this.props.data) {
      panels.newPanel.eventName = data.eventName;
      panels.newPanel.panelId = data.panelId;
      panels.getEventProperty();
      this.setState({
        open: true,
        tool: data.tool,
        type: data.type,
        eventName: data.eventName,
        property: data.property,
        submitConfirm: true,
        eventDisable: true,
        propertyDisable: false,
        toolDisable: false,
        typeDisable: false,
      })
    } else {
      this.setState({
        propertyDisable: true,
        toolDisable: true,
        typeDisable: true,
        eventDisable: false
      })
    }
  }
  render() {
    const { classes, show } = this.props;
    const { propertyDisable, toolDisable, typeDisable, eventDisable, eventName, propertyName } = this.state
    return (
      <div className="AddPanel">
        {show === 'add' ? <Tooltip title='創建面板'>
          <div className="AddPanel__addButton" onClick={this.addPanel}>
            <img src={addButton} alt='EventsAddButton' width={410} />
          </div>
        </Tooltip> : ''}
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{show === 'add' ? '創建面板' : '編輯面板'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">請選擇以下選項</DialogContentText>
            <div className={classes.root}>

              {/* detect select tool*/}
              {/* data visulizttion if then*/}
              {/* widget if then*/}

              <FormControl className={classes.formControl} required>
                <InputLabel htmlFor="eventName">事件</InputLabel>
                <Select
                  value={this.state.eventName}
                  onChange={this.handleEventNameChange}
                  inputProps={{
                    name: 'eventName',
                    id: 'eventName'
                  }}
                  disabled={eventDisable}
                  error={this.state.eventName == '' && this.state.submitConfirm ? true : false}
                >
                  {events.list.map((x, index) => (<MenuItem key={index} value={x.name}>{x.name}</MenuItem>))}
                </Select>
              </FormControl>
              <FormControl
                className={classes.formControl}
                required
                error={panels.newPanel.properties !== null
                  && panels.newPanel.properties instanceof Array
                  && panels.newPanel.properties.length === 0
                  && panels.newPanel.eventName !== ''
                  && true}
              >
                <InputLabel htmlFor="property">{propertyName}</InputLabel>
                <Select
                  value={this.state.property}
                  onChange={this.handlePropertyChange}
                  inputProps={{
                    name: 'property',
                    id: 'property'
                  }}
                  disabled={propertyDisable}
                  error={this.state.property == '' && this.state.submitConfirm ? true : false}
                >
                  {panels.newPanel.eventName === '' && <MenuItem value=''>請選擇一個事件</MenuItem>}
                  {panels.newPanel.properties !== null
                    ? panels.newPanel.properties instanceof Array && panels.newPanel.properties.length == 0
                      ? (<MenuItem value=''>
                        <em style={{ color: 'red' }}>
                          該事件內無有效屬性
                         </em>
                      </MenuItem>)
                      : panels.newPanel.properties.map((x,index) => (<MenuItem key={index} value={x}>{x}</MenuItem>))
                    : null
                  }
                  {/*? (<MenuItem value=''>
                       <em style={{color:'red'}}>
                         該事件內無有效屬性
                       </em>
                      </MenuItem>)
                    : panels.newPanel.properties.map((x) => (<MenuItem value={x}>{x}</MenuItem>))*/}
                  {/*{panels.newPanel.eventName === ''
                    ? null
                    : (panels.newPanel.properties !== null && panels.newPanel.properties instanceof Array && panels.newPanel.properties.length == 0)
                      ?(<MenuItem value=''>
                         <em style={{color:'red'}}>
                           該事件內無有效屬性
                         </em>
                       </MenuItem>)
                      :panels.newPanel.properties.map((x) => (<MenuItem value={x}>{x}</MenuItem>))
                    }*/}
                </Select>
                {panels.newPanel.properties !== null
                  && panels.newPanel.properties instanceof Array
                  && panels.newPanel.properties.length == 0
                  && panels.newPanel.eventName !== ''
                  &&
                  <FormHelperText>
                    請確保事件中至少有一個屬性<Hint />
                  </FormHelperText>}
              </FormControl>
              <FormControl className={classes.formControl} required>
                <InputLabel htmlFor="tool">工具</InputLabel>
                <Select
                  value={this.state.tool}
                  onChange={this.handleToolChange}
                  inputProps={{
                    name: 'tool',
                    id: 'tool'
                  }}
                  disabled={toolDisable}
                  error={this.state.tool == '' && this.state.submitConfirm ? true : false}
                >
                  <MenuItem value='dataVisualization'>數據可視化</MenuItem>
                  <MenuItem value='widget'>插件</MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl} required>
                <InputLabel htmlFor="type">類型</InputLabel>
                {this.state.tool == ''
                  ? <Select
                    value={this.state.type}
                    onChange={this.handleTypeChange}
                    inputProps={{
                      name: 'type',
                      id: 'type'
                    }}
                    disabled={typeDisable}
                    error={this.state.type == '' && this.state.submitConfirm ? true : false}
                  >
                    <MenuItem value=''>請選擇一種工具</MenuItem>
                  </Select>
                  : this.state.tool == 'dataVisualization'
                    ? <Select
                      value={this.state.type}
                      onChange={this.handleTypeChange}
                      inputProps={{
                        name: 'type',
                        id: 'type'
                      }}
                      disabled={typeDisable}
                      error={this.state.type == '' && this.state.submitConfirm ? true : false}
                    >
                      {/*<MenuItem value='gauge'>Gauge</MenuItem>*/}
                      <MenuItem value='line'>線圖</MenuItem>
                      <MenuItem value='area'>區域圖</MenuItem>
                    </Select>
                    : <Select
                      value={this.state.type}
                      onChange={this.handleTypeChange}
                      inputProps={{
                        name: 'type',
                        id: 'type'
                      }}
                      disabled={typeDisable}
                      error={this.state.type == '' && this.state.submitConfirm ? true : false}
                    >
                      <MenuItem value='toggleButton'>切換按鈕</MenuItem>
                    </Select>
                }
              </FormControl>
              {/*<FormControl className={classes.formControl} required>
                <TextField
                  id="panelName"
                  label="Name"
                  value={this.state.panelName}
                  onChange={this.handleEventNameChange('panelName')}
                  margin="normal"
                  required
                  error = {this.state.requireInputError}
                  helperText={this.state.requireInputError? this.state.errorType : false}
                />
              </FormControl>*/}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              取消
            </Button>
            <Button onClick={this.createPanel} color="primary" autoFocus>
              {show === 'add' ? '創建' : '編輯'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(AddPanel);



// WEBPACK FOOTER //
// ./src/components/AddPanel.js